import {Component, OnInit, Input, Optional, Self, ViewChild} from '@angular/core';
import {NgControl} from '@angular/forms';
import {BaseAnswerTypeComponent} from "../base-answer-type.component";
import {FileDto} from "../../../../models/file";
import {PublicFilesService} from "../../../../services/public-files.service";
import {finalize} from "rxjs/operators";
import {SimpleFileUploaderComponent} from "../../../../modules/simple-file-uploader/simple-file-uploader.component";
import {ConfigsLoaderService} from "../../../../services/config-loader.service";
import {ComparableOperator} from "../../../../models/form";
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-template-input',
  templateUrl: './template-input.component.html',
  styleUrls: ['./template-input.component.scss'],
})
export class TemplateInputComponent extends BaseAnswerTypeComponent<number> implements OnInit {
  @Input() maxLength: number = 200;
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() readonly: boolean = false;

  @Input() initialData: FileDto[];
  @Input() templateId: number;

  @Input() uploadEndpoint: string;

  @Input() allowedExtensions = '.doc,.DOC,.docx,.DOCX,.xml,.XML,.odt,.ODT,.pdf,.PDF,.rtf,.RTF,.txt,.TXT,.wpd,.WPD,.jpg,.JPG,.png,.PNG,.7z,.7Z,.rar,.RAR,.zip,.ZIP,.csv,.CSV,.bmp,.BMP,.svg,.SVG,.tif,.TIF,.tiff,.TIFF,.ods,.ODS,.xls,.XLS,.xlsm,.XLSM,.xlsx,.XLSX,.mp4,.MP4,.mp3,.MP3,.m4a,.M4A,.msg,.MSG,.ogg,.OGG,.opus,.OPUS,.pptx,.PPTX,.eml,.EML,.aac,.AAC,.gif,.GIF';
  @ViewChild('fileUploader') fileUploader: SimpleFileUploaderComponent;
  filesData: Partial<FileDto>[] = [];

  displayedColumns = [
    "name",
    "type",
    "size",
    "remove",
  ];
  matDatasource = new MatTableDataSource([]);


  readonly defaultValue = -1;
  public downloading = false;

  constructor(
    @Optional() @Self() ngControl?: NgControl,
    private uploadFileService?: PublicFilesService,
    private config?: ConfigsLoaderService,
  ) {
    super(ngControl);
  }

  ngOnInit() {
    this.uploadEndpoint = `${this.config.apiUrl}/File/UploadFileFormTemplateAnswer`;
  }


  ngAfterViewInit() {
    super.ngAfterViewInit();

    this.fileUploader.changes.subscribe(files => {
      const fileID = files[0]?.id || this.defaultValue;
      this.setValue(fileID);
      this.matDatasource.data = [...files];
    });

    this.matDatasource.data = this.initialData;
  }

  downloadTemplate() {
    this.downloading = true;
    this.uploadFileService.downloadFileTemplate(this.templateId)
      .pipe(
        finalize(() => this.downloading = false),
      ).subscribe();
  }

  AllowedOperators: {[K in ComparableOperator]: (t: number, value: any) => boolean} = {
    [ComparableOperator.Equal]: null,
    [ComparableOperator.NotEqual]: null,
    [ComparableOperator.Contains]: null,
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: null,
    [ComparableOperator.GreaterThan]: null,
    [ComparableOperator.GreaterThanOrEqual]: null,
    [ComparableOperator.LessThan]: null,
    [ComparableOperator.LessThanOrEqual]: null,
    [ComparableOperator.IsNullOrEmpty]: (target) => !target,
    [ComparableOperator.NotIsNullOrEmpty]: (target) => !!target,
    [ComparableOperator.Between]: null,
    [ComparableOperator.Empty]: null,
    [ComparableOperator.Completed]: null,
  }
}
